module.exports = __webpack_public_path__ + "img/y-28.b01dda93.png";